import styled from "styled-components";
import { FileUpload } from "../../../../../Components/Upload/Upload.styled";

export const TextEditorWrapper = styled.div`
  border: 1px solid #e3e6e8;
  border-radius: 4px;
`;
export const teaserTextStyle = {
  fontSize: "15px",
  lineHeight: "19px"
};

export const SectionHeader = styled.h2`
  text-align: left;
  font-size: 1rem;
  margin: 2rem 0 1rem;
  color: rgb(122, 137, 244);
`;

export const SectionLabel = styled.label`
  font-size: 1rem;
  margin: ${({ bottom }) => (bottom ? "0 0 1rem" : "1rem 0 0.625rem")};
  color: rgb(122, 137, 244);
`;

export const SelectOptions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 1.8rem;
`;

export const AlternativeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const TextSectionWrapper = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;

  &:nth-child(1) {
    flex: 0 0 45%;
  }

  &:nth-child(2) {
    flex: 0 0 50%;
  }

  &:nth-child(3) {
    flex: 0 0 45%;
  }

  &:nth-child(4) {
    flex: 0 0 50%;
  }
`;

export const GenerateAudioSection = styled.div`
  margin-bottom: 1.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;

  ${FileUpload} {
    display: flex;
    align-items: center;
    margin: 0;
    background: transparent;
    padding: 5px 20px;
    border-radius: 3px;
    border: 1px solid rgba(21, 22, 51, 0.11);
    height: 100%;
    border: 1px solid #7a89f4;
    &:hover {
      background: ${({ color }) => color || "#dce0fc"};
      border: 1px solid ${({ color }) => color || "#dce0fc"};
    }
  }

  > div:last-child {
    width: 100%;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 6px;

  > div > div {
    height: 100%;
  }
`;

export const LoadingIndicatorWrapper = styled.div`
  display: flex;
  justify-content: center;

  svg {
    width: 13px;
    height: 13px;
  }
`;

export const AudioGeneratorSelector = {
  control: (css) => ({
    ...css,
    cursor: "pointer"
  }),
  menu: (css) => ({
    ...css,
    justifyContent: "flex-start"
  }),
  menuList: (css) => ({
    ...css,
    maxHeight: "300px"
  })
};
